import { EndpointSetting } from "@/constants/app/type";
import { UserState } from "../type";

export const callbackValidateResetToken: EndpointSetting['caller'] = (
  state: UserState,
  action: any,
  endpointName: any
) => {
  state.validate_reset_token.loading = false;
  state.validate_reset_token.error = null;
  state.validate_reset_token.success = true;
  state.validate_reset_token.data = action.payload;
}